// Webpack Imports
//import * as bootstrap from 'bootstrap';

jQuery(document).ready(function($){
	'use strict';

	//Initilaise AOS
	AOS.init({
		duration: 1200,
		once: true,
	});

// $('.resource-download-carousel').flickity({
//   // options
//   cellAlign: 'center',
//   contain: true,
//   wrapAround: true,
//   groupCells: 1,
//   autoPlay: true,
//   autoPlay: 5000,
//   fade: true,
//   prevNextButtons: true,
// 	pageDots: true
// });

var screenHeight = jQuery(window).height();
var screenWidth = jQuery(window).width();

  $('.insights-carousel').each(function(){  
      var highestBox = 0;

      $(this).find('.equal-height').each(function(){
          if($(this).height() > highestBox){  
              highestBox = $(this).height();  
          }
      })

      $(this).find('.equal-height').height(highestBox);
  });  

	//Equalize heights
	(function matchHeight(){
  //Grab divs with the class name 'match-height'
  var getDivs = document.getElementsByClassName('match-height');

  //Find out how my divs there are with the class 'match-height' 
  var arrayLength = getDivs.length;
  var heights = [];

  //Create a loop that iterates through the getDivs variable and pushes the heights of the divs into an empty array
  for (var i = 0; i < arrayLength; i++) {
      heights.push(getDivs[i].offsetHeight);
  }

   //Find the largest of the divs
  function getHighest() {
    return Math.max(...heights);
  }

  //Set a variable equal to the tallest div
  var tallest = getHighest();

  //Iterate through getDivs and set all their height style equal to the tallest variable
  for (var i = 0; i < getDivs.length; i++) {
      getDivs[i].style.height = tallest + "px";
  }
})();

	(function matchHeightTitle(){
  //Grab divs with the class name 'match-height-title'
  var getDivs = document.getElementsByClassName('match-height-title');

  //Find out how my divs there are with the class 'match-height' 
  var arrayLength = getDivs.length;
  var heights = [];

  //Create a loop that iterates through the getDivs variable and pushes the heights of the divs into an empty array
  for (var i = 0; i < arrayLength; i++) {
      heights.push(getDivs[i].offsetHeight);
  }

   //Find the largest of the divs
  function getHighest() {
    return Math.max(...heights);
  }

  //Set a variable equal to the tallest div
  var tallest = getHighest();

  //Iterate through getDivs and set all their height style equal to the tallest variable
  for (var i = 0; i < getDivs.length; i++) {
      getDivs[i].style.height = tallest + "px";
  }
})();

	//Header animation
	var new_scroll_position = 0;
	var last_scroll_position;
	var header = document.getElementById("header-animate");

	window.addEventListener('scroll', function(e) {
	  last_scroll_position = window.scrollY;

	  // Scrolling down
	  if (new_scroll_position < last_scroll_position && last_scroll_position > 80) {
	    // header.removeClass('slideDown').addClass('slideUp');
	    header.classList.remove("slideDown");
	    header.classList.add("slideUp");

	  // Scrolling up
	  } else if (new_scroll_position > last_scroll_position) {
	    // header.removeClass('slideUp').addClass('slideDown');
	    header.classList.remove("slideUp");
	    header.classList.add("slideDown");
	  }

	  new_scroll_position = last_scroll_position;
	});

	// Hamburger offcanvas menu
	const navExpand = [].slice.call(document.querySelectorAll(".nav-expand"));
	const backLink = `<li class="nav-item">
		<a class="nav-link nav-back-link" href="javascript:;">
			Back
		</a>
	</li>`;

	navExpand.forEach((item) => {
		item
			.querySelector(".nav-expand-content")
			.insertAdjacentHTML("afterbegin", backLink);
		item
			.querySelector(".nav-link")
			.addEventListener("click", () => item.classList.add("active"));
		item
			.querySelector(".nav-back-link")
			.addEventListener("click", () => item.classList.remove("active"));
	});

	// ---------------------------------------
	// not-so-important stuff starts here

	const body = document.querySelector('body');
	const burger = document.querySelector('.ham');
	burger.addEventListener('click', (e) => {
	burger.classList.toggle('open');
	  e.preventDefault();
	  body.classList.toggle('nav-is-toggled')
	});

	// var ham = document.querySelector('.ham');
	// ham.addEventListener("click", function () {
	// 	document.body.classList.toggle("nav-is-toggled");
	// });


	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// Fonts loader
	var MTUserId='45da5564-4010-44a6-aaaf-4321d7b6683d';
    var MTFontIds = new Array();

    MTFontIds.push("5173092"); // Avenir® W05 55 Roman 
    MTFontIds.push("5194955"); // Avenir® W05 35 Light 
    MTFontIds.push("5686127"); // Avenir® W05 65 Medium 
    MTFontIds.push("5687178"); // Avenir® W05 45 Book 
    MTFontIds.push("5687390"); // Avenir® W05 85 Heavy 
    MTFontIds.push("6237457"); // Avenir® W05 95 Black 
    (function() {
        var mtTracking = document.createElement('script');
        mtTracking.type='text/javascript';
        mtTracking.async='true';
        mtTracking.src='mtiFontTrackingCode.js';

        (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(mtTracking);
    })();

document.addEventListener("DOMContentLoaded", function(){
	if (window.innerWidth > 992) {
	    document.querySelectorAll('.navbar-nav .nav-item').forEach(function(everyitem){
	        everyitem.addEventListener('mouseover', function(e){
	            let el_link = this.querySelector('a[data-bs-toggle]');
	            if(el_link != null){
	                let nextEl = el_link.nextElementSibling;
	                el_link.classList.add('show');
	                nextEl.classList.add('show');
	            }
	        });
	        everyitem.addEventListener('mouseleave', function(e){
	            let el_link = this.querySelector('a[data-bs-toggle]');
	            if(el_link != null){
	                let nextEl = el_link.nextElementSibling;
	                el_link.classList.remove('show');
	                nextEl.classList.remove('show');
	            }

	        });
	        everyitem.addEventListener('click', function(e){
	            let el_link = this.querySelector('a[data-bs-toggle]');
	            if(el_link != null){
	                location.href = el_link.href;
	            }

	        });
	    });
	}
	if($(window).width() < 769){

$( ".dropdown-toggle" ).append( "<span class='mobile-toggler'></span>" );

		$('.mobile-toggler').click(function(e) {

			$(this).addClass("active");
    e.preventDefault();
    e.stopPropagation();

    return false;
});

        $('.navbar-nav .dropdown').hover(function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

        }, function() {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

        });

        $('.navbar-nav .dropdown > a').click(function(){
            location.href = this.href;
        });

    }
}); 


document.addEventListener("DOMContentLoaded", function(){
// make it as accordion for smaller screens
if (window.innerWidth > 992) {

	document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){

		everyitem.addEventListener('mouseover', function(e){

			let el_link = this.querySelector('a[data-bs-toggle]');

			if(el_link != null){
				let nextEl = el_link.nextElementSibling;
				el_link.classList.add('show');
				nextEl.classList.add('show');
			}

		});
		everyitem.addEventListener('mouseleave', function(e){
			let el_link = this.querySelector('a[data-bs-toggle]');

			if(el_link != null){
				let nextEl = el_link.nextElementSibling;
				el_link.classList.remove('show');
				nextEl.classList.remove('show');
			}


		})
	});

}
// end if innerWidth
}); 
// DOMContentLoaded  end

});